/**
 * Class description
 *
 * Created: 2019-07-31
 * @author jonas
 */

import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StandardAutoCloseGameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {TimelineLite,TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../display/BasicBitmapCountUp";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {ImmortalFruitsTextStyles} from "../config/ImmortalFruitsTextStyles";
import {CountDownTimer} from "@nolimitcity/slot-game/bin/core/component/CountDownTimer";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bonusWheelEvents} from "../gameround/bonusWheelController";
import {ImmortalFruitsGameModuleConfig} from "../ImmortalFruitsGameModuleConfig";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {freezeLayers} from "../utils/freezeGame";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SoundManager} from "../resource/sound/SoundManager";
import {ImmortalFruitsSoundConfig} from "../ImmortalFruitsSoundConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";


export class ImmortalFruitsbonusViewOutroView extends StandardAutoCloseGameModeTransitionView {
    private _compCallback:() => void;
    private _gameGraphics:PIXI.Container;
    private _youWonText:PIXI.Text;
    private _gameBackground:PIXI.Container;
    private _totalWin:number;
    private _bitmapText:BasicBitmapCountUp;
    private _isBigWin:boolean = false;
    private outroSpine:PIXI.spine.Spine;
    private outroSpineTween:SpineTween;

    private blurNotSkipped :boolean =true;

    constructor(layer:ScalableLayer, autoCloseTimerDuration:number = 20) {
        super(layer, autoCloseTimerDuration);
    }

    protected createBackground():PIXI.DisplayObject {
        this._gameBackground = new PIXI.Container();
        this._gameBackground.name = "Background";
        this._gameBackground.pivot.set(0.5);
        this._gameBackground.visible = false;
        return this._gameBackground;
    }
    private internalImmortalCompleteCallback() {
        ImmortalFruitsGameModuleConfig.countUpView.end(this._totalWin, 0, 0, false, false, true);
            let tl = new TimelineLite({onComplete:()=>{
                }});
        this._button.alpha =0;
        this._button.enabled =false;
            tl.add(()=>{

                this.stopTimerAndDisableButton();
                SoundManager.playContinueBtn();
                this.outroSpineTween = new SpineTween(this.outroSpine, 0, "outro_end",0);
                this._youWonText.visible =false;
                this._bitmapText.alpha =0;
                this.blurNotSkipped = false;
                TweenLite.to((this._bitmapText) ,this.outroSpineTween.totalDuration()-0.4,{alpha:0});
                TweenLite.to((this._youWonText) ,this.outroSpineTween.totalDuration()-0.4,{alpha:0});
                StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name).getChildByName("reelAreaCover").alpha=0;
                freezeLayers.removeBlur(this._layer);

                TweenLite.to(() => {},this.outroSpineTween.totalDuration(),{onComplete:()=>{
                    this.outroSpine.renderable =false;
                        this._youWonText.visible =false;
                        this._youWonText.alpha =1;
                        this._bitmapText.alpha =0;
                        this._compCallback();
                        ImmortalFruitsGameModuleConfig.featurePrice.reset();
                        SlotGame.keypad.show();
                        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));

                    }});
             },0)
    }
    protected createButton():NineSliceButton {
        const text:string = Translation.translate("CONTINUE");
        const textStyle:TextStyleOptions = this.getImmortalcaledButtonTextStyle();
        const button = new NineSliceButton(() => this.internalImmortalCompleteCallback(), ` ${text} `, textStyle);
        button.enabled = false;
        return button;
    }
    private getImmortalcaledButtonTextStyle():TextStyleOptions {
        const style:TextStyleOptions = this.BUTTON_TEXT_STYLE;
        if(typeof style.fontSize !== 'number') {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        style.fontSize = (<number>style.fontSize) * this._deviceScale;
        return style;
    }
    public startTimerAndEnableButton(callback:() => void) {
        ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE = ImmortalFruitsGameModuleConfig.featurePrice.isWinBelowStake();
        this._gameBackground.addChild(this._gameGraphics);
        this._compCallback = callback;

        this._button.visible = true;
        this._gameBackground.visible = true;
        this._gameGraphics.visible = false;
        let startOffSet =0.5;
        let tl = new TimelineLite({onComplete:()=>{
                tl.clear();
                tl.kill()
            }});
        let duration = ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE ? 0 : 1; // #305 automatically stops the coutup sounds on outro
        if(this._isBigWin){
            duration = 0.01;
            startOffSet =1.5;
        }
        this.outroSpineTween = new SpineTween(this.outroSpine, 0, "outro_start", 0);
        this._gameGraphics.visible =true;
        tl.add(()=>{

            this.outroSpine.renderable =true;
            this.outroSpine.state.setAnimation(0,"outro_start",false);
            duration > 0 && SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELOUTROEND, undefined, 1);
            EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.HIDE_WHEELS));
            SoundManager.fadeInMainBGSound(2000);
            if(this.blurNotSkipped){
                StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name).getChildByName("reelAreaCover").alpha=1;
                freezeLayers.addBlur(this._layer);
            }
        },startOffSet);
        tl.add(()=>{
            SoundManager.fadeOutBonusBG(100);
            //#219 timing for sound
        },startOffSet+0.181);
        tl.add(()=>{
            this._youWonText.visible = !ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE;
            this.outroSpineTween = new SpineTween(this.outroSpine, 0, "outro_loop", -1);
            this._bitmapText.alpha=1;
            this._bitmapText.preCalculateScale(0, this._totalWin);
            this._bitmapText.getCountAnimation(0, this._totalWin, duration);
            duration > 0.01 && SoundManager.playCountUp();
        },startOffSet+this.outroSpineTween.totalDuration());
        tl.add(()=>{
            this._button.alpha =1;
            this._button.enabled = true;
            this._bitmapText.stopAt(this._totalWin);
            SoundManager.stopCountUp();
            duration > 0.01 && SoundManager.playCountUpEnds();
       // },startOffSet+this._outroStart.totalDuration+duration);
        },startOffSet+this.outroSpineTween.totalDuration()+duration);

        this._button.alpha =0;

    }

    public stopTimerAndDisableButton() {
        this._button.enabled = false;
        this._button.visible = false;
    }
    protected createAutoCloseTimer(): CountDownTimer {
        const tmr:CountDownTimer = super.createAutoCloseTimer();
        return tmr;
    }
    protected createGameGraphics():PIXI.DisplayObject {
        this.outroSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("outro"));
        this.outroSpine.renderable =false;

        this._autoCloseTimer = this.createAutoCloseTimer();
        this._autoCloseTimer.visible =false;
        this._gameGraphics = new PIXI.Container();
        this._gameGraphics.name = "_gameGraphics";
        this._youWonText = new PIXI.Text(Translation.translate("Total Win"), {fill : 0xffffff, fontSize : 50,wordWrap:true,wordWrapWidth:300, align:"center"});
        this._youWonText.anchor.set(0.5);
        this._youWonText.position.set(0,-30);
        this._gameGraphics.addChild(this._youWonText);
        this._bitmapText = new BasicBitmapCountUp( ImmortalFruitsTextStyles.WHEEL_NUM, 490, new PIXI.Point(0.5));
        this._bitmapText.pivot.set(0.5,0.8);
        this._gameGraphics.visible = false;
        this._youWonText.visible = false;
        this._youWonText.y =-53;
        this._youWonText.x =20;
        this._bitmapText.x =10;
        this._bitmapText.y =10;
        this._gameGraphics.addChild(this.outroSpine);
        this._gameGraphics.addChild(this._youWonText, this._bitmapText);
        return this._gameGraphics;
    }
    protected onResize(data: IResizeData): void {
        super.onResize(data);
        if(this.blurNotSkipped){
            freezeLayers.onResize(this._layer)//#175 #178 fixed
        }
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        if ("portrait" == data.orientation) {
            this._gameBackground.position.set(NolimitApplication.screenBounds.width / 2-11, NolimitApplication.screenBounds.height / 2-68);
        }else{
            this._gameBackground.position.set(NolimitApplication.screenBounds.width / 2-11, NolimitApplication.screenBounds.height / 2+22);
        }
    }
    prepare(data: ImmortalFruitsParsedGameData): void{
        this._totalWin = data.singleWin;
       this._isBigWin = (data.singleWin / data.playedBetValue)> (ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[0].ratio);
    }
    /**
     * @description To implement any animation for this view.
     * @param prepareToEnterModeCallback
     * @param completeCallback
     */
    public getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        SlotGame.keypad.hide();
        this.blurNotSkipped = true;
        this._gameGraphics.visible =false;
        this.startTimerAndEnableButton(completeCallback);
        this._layer.addChild(this);
        this._mainGraphicsContainer.alpha=1;
        this._fullScreenFade.alpha=0;
        this._bitmapText.alpha=0;
        this._youWonText.visible =false;
        const tl = new TimelineLite();// super.getStartAnimation(prepareToEnterModeCallback, completeCallback);
        return tl;
    }
}
